import { writable } from "svelte/store";
import { user, alert, get__store } from '../store.js';
import { Projects, ProjectRequest, ProjectsRequest } from "../../proto/task_pb";
import { ProjectServicePromiseClient } from "../../proto/task_grpc_web_pb";

export const projects = writable([]);


export class Projectsvc {
    constructor(deps) {
        this.proto = {
            ProjectsRequest,
            ProjectRequest,
            Projects,
            ProjectClient: ProjectServicePromiseClient,
        }
        this.client = new this.proto.ProjectClient(VITE_APIURL, null, null)
        this.refresh()
    }

    setJWT() {
        return {
            ["X-CSRF-Token"]: get__store(user).accessToken,//'localStorage.getItem("X-CSRF-Token")',
        };;
    }

    getProjects() {
        return projects
    }

    refresh() {
        projects.set([]);
        const req = new this.proto.ProjectsRequest()
        this.client.index(req, this.setJWT()).then(res => {
            res.getProjects().getProjectList().map(project => {
                projects.update(n => [...n, svelteprojectfromproto(project)])
            })
        }).catch (e => {
        console.log("Error retrieving projects", e);
        alert.update((n) => [
            ...n,
            "Failed to retrieve projects " + e.message,
        ]);  
    });
    
        return
    }
    completed() {
        const req = new this.proto.ProjectRequest()
        return this.client.projectcompleted(req, this.setJWT()).then(res => {
            return res.getProjectList()
        }).catch (e => {
            console.log("Error retrieving completed projects", e);
            alert.update((n) => [
                ...n,
                "Failed to completed projects " + e.message,
            ]);  
        });
    }
    add(data) {
        let req = new this.proto.ProjectRequest()
        req.setProject(protobuffromsvelteproject(data))
        this.client.add(req, this.setJWT()).then(res => {
            res.getProjects().getProjectList().map(project => {
                projects.update(n => [...n, svelteprojectfromproto(project)])
            })
        }).catch (e => {
            console.log("Error adding project", e);
            alert.update((n) => [
                ...n,
                "Failed to adding projects " + e.message,
            ]);  
        });
        return
    }

    update(arguements) {
        arguements.forEach(item => {
          let req = new this.proto.ProjectRequest()
          //projects.set(get__store(projects).filter(project => project.id != item.id));
          req.setProject(protobuffromsvelteproject(item))
          this.client.update(req, this.setJWT()).catch( e => {
            console.log("Error updating project", e);
            alert.update((n) => [
                ...n,
                "Failed to update project " + e.message,
                ])
            })
        })
        //Clear out archived projects from store
        projects.set(get__store(projects).filter(project => project.status != 2));
        return
    }

}


export function svelteprojectfromproto(data) {
    return {
        id: data.getId(),
        name: data.getName(),
        description: data.getDescription(),
        status: data.getStatus(),
        nextaction: data.getNextaction(),
        updatedAt: data.getUpdatedAt(),
        createdAt: data.getCreatedAt(),
        viewedAt: data.getViewedAt(),
        priority: data.getPriority(),
    }
}
export function protobuffromsvelteproject(data) {
    let tsk = new proto.proto.Project
    tsk.setId(data.id)
    tsk.setName(data.name)
    tsk.setDescription(data.description)
    tsk.setStatus(data.status)
    tsk.setPriority(data.priority)
    tsk.setNextaction(data.nextaction)
    tsk.setViewedAt(data.viewedAt)
    return tsk
}